module.exports = __webpack_public_path__ + "static/img/img_pass@2x.1786686659715.png";